/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import { Typography, Card } from '@mui/material';
import BackButton from '../BackButton';
import DashcamImage from "../../../../../../assets/images/ArticleImages/What-is-a-Dash-Cam.webp";
import Dashcam1 from "../../../../../../assets/images/ArticleImages/What-is-a-Dash-Cam1.webp";
import Advantages from "../../../../../../assets/images/ArticleImages/Advantages.webp";
import MustHaveFeatures from "../../../../../../assets/images/ArticleImages/Must-Have-Features.webp";
import Telematics from "../../../../../../assets/images/ArticleImages/Dash-Cams-and-Video-Telematics.webp";

// Define a type for the content blocks
type ContentBlock =
    | { type: 'heading'; value: string; variant?: 'h4' | 'h5' | 'h6' | 'subtitle2'; style?: React.CSSProperties }
    | { type: 'paragraph'; value: string; style?: React.CSSProperties }
    | { type: 'image'; src: string; alt?: string; style?: React.CSSProperties };

const DashCam: React.FC = () => {
    // Page header information
    const title = "What is a Dashcam? Its Role in Accident Prevention";
    const headerImageSrc = DashcamImage;

    // Define the content of your article as a list of blocks.
    const contentBlocks: ContentBlock[] = [
        {
            type: 'heading',
            value: "Introduction",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "Dash cams, short for dashboard cameras, have become an essential tool in modern vehicles, playing a critical role in road safety, fleet management, and driver liability protection. They offer invaluable support in capturing footage of incidents and improving accountability. In cases when incidents get on record, dash cams offer invaluable support and enhance accountability.",
        },
        {
            type: 'paragraph',
            value: "Novus Hitech provides cutting-edge AI-powered solutions that bring dash cam technology to the next level of smartness and reliability. In this post, we will focus on what is a dashcam, how AI augments its features, the benefits of installing one, and the primary aspects to look into if you are going to purchase it.",
        },
        {
            type: 'heading',
            value: "What is a Dashcam? How AI is Revolutionizing Dash Cams?",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: Dashcam1,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'heading',
            value: "Let’s explore what is a dashcam & its  approximate size",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "The size of a small camera mounted on the windshield or dashboard of a vehicle that continuously records what is visible from the front or rear windows. Many individuals use dash cams to record road incidents, monitor driver behavior, and even prevent false claims of accidents.",
        },
        {
            type: 'paragraph',
            value: "But with the integration of AI, the seemingly simple reading device dash cam is now transformed into an intelligent system which can conduct real time analysis to alert drivers of risks and even predict accidents before it happens.",
        },
        {
            type: 'paragraph',
            value: (
                <>
                <strong>AI in dash cams</strong> adds layers of smart functionality beyond the traditional definition of this feature. As such, it can detect distracted driving, alert drivers when they drift from their lanes, or warn them about proximity to another car and hence promotes safer driving habits. This, in turn, helps in reducing consumption and accidents, as it provides timely warnings to drivers.
                </>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "Advantages of Installing a Dash Cam",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: Advantages,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "Apart from these key features/advantages, dash cam installation offers numerous other benefits to people in terms of fleet management or personal safety. Here is a breakdown of the key advantage:",
        },
        {
            type: 'paragraph',
            value: (
                <>
                1.<strong> Efficient Fleet Management:</strong> Dash cams are used by fleet operators to monitor the behavior of drivers and comply with all the implemented safety measures. Through video analysis, managers find the most efficient routes, improved fuel economy, and lower cases of dangerous driving practices.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                2.<strong> Enhanced Safety:</strong> Dash cams promote safe driving by giving instant feedback and issuing alarms in respect of potential dangers with which the driver might eventually be confronted. In this regard, accidents can be stopped in their tracks.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                3.<strong> Security and Theft Prevention Theft:</strong> Many of the dash cams are equipped with motion detection capabilities. This helps capture even when the car has been parked. This is very helpful in case of premeditated theft or vandalism. Any suspicious activity around the car would be recorded and reviewed later.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                4.<strong> Reliable Video Evidence:</strong> If an accident occurs, then footage shot by a dash cam forms a great record of events that can help pin the blame and negate the claims. This will reduce disputations in the court and therefore lower insurance rates.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                5.<strong> Safer Driving Moments:</strong> The fact that a driver’s actions will be captured causes the driver to maintain safer driving habits. It is very helpful to businesses running large fleets wherein accountability of the drivers is crucial.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                6.<strong> Capturing Unexpected Moments:</strong> It is not just for safety and security but also recording unique instances on the road, even when they turn out surprising. Dash cameras record everything from scenic drivers to rare incidents such as meteor sightings that otherwise go unremembered.
                </>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "Must-Have Features and uses to Look for in a Dash Cam",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: MustHaveFeatures,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "This is what you ought to look at when shopping for a dash cam so that you get the best performance based on your needs:",
        },
        {
            type: 'paragraph',
            value: (
                <>
                <strong>Mounting Options:</strong> Versatile mounting options-like suction cups or adhesives, for instance-made available months before installation and repositioning.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                <strong>Memory Storage and Capacity:</strong> Choose a model with ample storage capacity or not that supports expandable memory through SD cards. High designation footage requires more space, so consider the resolution you’ll be recording at. 
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                <strong>Video Quality and Resolution:</strong> To capture crucial details like license plates, opt for a dash cam with at least 1080p resolution. Some models even offer 4k for crystal-clear video quality.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                <strong>Audio Quality and Resolution:</strong> Some dash cams can record audio inside the vehicle, which can be useful in understanding the content of an event or accidents.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                <strong>App connectivity and GPS Tracking:</strong> For enhanced convenience, choose a dash cam that connects to your smartphone through an app, allowing you to review footage remotely. GPS tracking can also provide location data, which is particularly helpful for fleet managers.
                </>
            ) as unknown as string,
        },
        {
            type: 'paragraph',
            value: (
                <>
                <strong>Cost Considerations:</strong> While high-end dash cams come with advanced features, there are also budget-friendly models that offer essential functionally. Balance cost with the features you need to ensure you make the best investment.
                </>
            ) as unknown as string,
        },
        {
            type: 'heading',
            value: "Dash Cams and Video Telematics: A Powerful Combination",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'image',
            src: Telematics,
            alt: "Connected vehicles schematic",
            style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
        },
        {
            type: 'paragraph',
            value: "Video telematics combine the functionality of dash cams with advanced telematics systems for the purpose of viewing driver behavior, vehicle health, and road conditions. This leads to an all-in-one solution in fleet management and accident prevention.",
        },
        {
            type: 'paragraph',
            value: "Video telematics allow fleet managers to view video footage as recorded in real time to take prompt action against unsafe driving or other critical events. The system tracks speed, braking, and other performance metrics, thereby allowing companies to have a full, detailed view of how their fleets are operating-and lowering costs associated with consumption of fuel and deterioration of vehicles.",
        },
        {
            type: 'paragraph',
            value: "In combination with video telematics, a camera set up by a state-of-the-art AI from dash cam offers unmatched safety benefits. The system can be used to analyze driving behavior and send alerts over harsh braking, or for tailgating, and it can make use of immediate feedback in preventing accidents, making it a game-changer both for individual drivers and fleet operators.",
        },
        {
            type: 'heading',
            value: "Conclusion",
            variant: 'h6',
            style: { marginTop: '16px', marginBottom: '8px' },
        },
        {
            type: 'paragraph',
            value: "Dash cams & Video telematics are more than just a safety tool but also a prevention tool against accidents, accountability on the part of drivers, and securing critical video evidence at the time of accidents. The integration of AI makes dash cams an indispensable tool for those who aim to optimize their fleet’s road safety or its performance. Whether you are a fleet manager, running a business, or commuting, investing in an AI-capable dash cam can enhance safety and save money simultaneously give you peace of mind while driving. Contact Novus Hitech today. Our team can help you implement the right AI solutions to upscale your fleet performance and enhance road safety.",
        },
    ];

    // Function to render each content block based on its type.
    const renderContentBlock = (block: ContentBlock, index: number) => {
        switch (block.type) {
            case 'heading':
                return (
                    <Typography
                        key={index}
                        variant={block.variant || 'h4'}
                        style={{ fontWeight: 600, ...block.style }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'paragraph':
                return (
                    <Typography
                        key={index}
                        variant="body1"
                        style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            // color: 'gray',
                            ...block.style,
                        }}
                    >
                        {block.value}
                    </Typography>
                );
            case 'image':
                return (
                    <Card
                        key={index}
                        style={{
                            overflow: 'hidden',
                            borderRadius: 12,
                            ...block.style,
                        }}
                    >
                        <img
                            src={block.src}
                            alt={block.alt || 'Article image'}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Card>
                );
            default:
                return null;
        }
    };

    return (
        <div className="flex flex-col w-full">
            <BackButton />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
                {/* Header Section */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '766px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                    }}
                >
                    {/* Title & Tag Section */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Typography variant="h4" style={{ fontWeight: 600 }}>
                            {title}
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '8px',
                            }}
                        >
                        </div>
                    </div>

                    {/* Header Image */}
                    <Card
                        style={{
                            width: '100%',
                            height: 384,
                            borderRadius: 12,
                            overflow: 'hidden',
                        }}
                    >
                        <img
                            src={headerImageSrc}
                            alt="Article header image"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </Card>
                </div>

                {/* Content Section */}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '766px',
                        padding: '16px 0',
                    }}
                >
                    {contentBlocks.map((block, index) => renderContentBlock(block, index))}
                </div>
            </div>
        </div>
    );
};

export default DashCam;

